import { MessageSquare } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/hooks";
import { openDirectThread } from "../../features/messages/slice-extensions/messages-slice-extension";
import { ROUTES } from "../../routes";

interface MessageMemberButtonProps {
  memberId: string;
}

/** The member page's "Message" action: opens (or starts) the member's direct thread. */
const MessageMemberButton = ({ memberId }: MessageMemberButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    const result = await dispatch(openDirectThread(memberId));
    setBusy(false);
    if (openDirectThread.fulfilled.match(result)) {
      navigate(ROUTES.MESSAGE_THREAD.replace(":threadId", result.payload.id));
    } else {
      toast.error(t("messages.openFailed"));
    }
  };

  return (
    <button type="button" className="btn btn-secondary flex items-center gap-1.5" onClick={open} disabled={busy}>
      <MessageSquare size={18} />
      {t("messages.action.message")}
    </button>
  );
};

export default MessageMemberButton;
